<div *ngIf="this.systemNotification != null && this.systemNotification.notification != ''" class="SystemNotification-Container" [class]="systemNotification.priority">
  <div class="notification-icon col-1">
    <mat-icon *ngIf="systemNotification.priority == 'Info'">info</mat-icon>  
    <mat-icon *ngIf="systemNotification.priority == 'Warning'">warning</mat-icon>  
    <mat-icon *ngIf="systemNotification.priority == 'Danger'">new_releases</mat-icon>  
    <mat-icon *ngIf="systemNotification.priority == 'Success'">done_outline</mat-icon>  
  </div>
  <div class="col-10">
    {{ systemNotification.notification }}
  </div>
  <div class="notification-btnClose col-1">
    <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="CloseNotification()"></mat-icon>
  </div>
</div>